import { Pencil } from 'lucide-react'

export const EditMark = () => (
  <Pencil className="mt-[0.2em] size-3 shrink-0 text-ink-subtle opacity-0 transition-opacity group-hover/field:opacity-100" />
)
